import { Box, Typography } from '@mui/material';

import { QuestionProps } from '@/models/Question';

function SubheaderText({ question }: { question: QuestionProps }) {
  if (!question) return null;

  return (
    <>
      <Box display='flex' alignItems='center'>
        <Typography style={{ marginTop: '10px' }} variant='h4'>
          {question.questionText}
        </Typography>

        <Typography style={{ marginBottom: '15px' }}>{question.questionNote}</Typography>
      </Box>
    </>
  );
}

export default SubheaderText;
